import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import adminRoutes from './admin.routes'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/auth/LoginForm.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../components/auth/ForgotPassword.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/reset-password/:uid/:token',
    name: 'ResetPassword',
    component: () => import('../components/auth/ResetPassword.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/Dashboard/Dashboard.vue'),
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/portfolio/:id?',
    name: 'Portfolio',
    component: () => import('../components/Portfolio/Portfolio.vue'),
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: () => import('../components/Transaction/TransactionView.vue'),
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/dividends',
    name: 'Dividendes',
    component: () => import('../components/Dividend/DividendManager.vue'),
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  ...adminRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Si la route nécessite une authentification
  if (to.meta.requiresAuth) {
    // Si l'utilisateur n'est pas authentifié
    if (!authStore.isAuthenticated) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
    
    // Vérifier la validité du token
    try {
      const isValid = await authStore.checkAuth()
      if (!isValid) {
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
      }
      
      // Vérifier les permissions admin si nécessaire
      if (to.meta.requiresAdmin && authStore.user?.role_id !== 1) {
        next('/dashboard')
        return
      }
      
      next()
    } catch (error) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    // Rediriger vers le dashboard si déjà connecté
    const redirect = to.query.redirect || '/dashboard'
    next(redirect)
  } else {
    next()
  }
})

router.afterEach((to) => {
  // Mettre à jour le titre de la page
  document.title = to.name ? `${to.name} - Portfolio Manager` : 'Portfolio Manager'
})

export default router

